import { useMemo } from 'react';

import adminProductSerialNumberService from '@services/admin/productSerialNumberService';

// Re-export 型別給 caller，省去跨層 import service 模組
export type {
  ProductSerialNumberDetail,
  ProductSerialNumberInventory,
  ProductSerialNumberRecord,
  ProductSerialNumberStatus,
  ProductSerialNumberTimelineEvent,
  ProductSerialNumberTimelineEventType,
} from '@services/admin/productSerialNumberService';

/**
 * Admin Product Serial Number Service Hook
 *
 * 簡單包裝 adminProductSerialNumberService，保持與 useAdminInboundService /
 * useAdminProductService 等 admin hook 一致的 useMemo wrapper 形態。
 *
 * @example
 * const psnService = useAdminProductSerialNumberService();
 *
 * const list = await psnService.getRecords({ numbers: ['SN-0001'] });
 * const detail = await psnService.getById('abc-uuid');
 */
export function useAdminProductSerialNumberService() {
  return useMemo(() => adminProductSerialNumberService, []);
}
